import styled from "styled-components";
import Infinite from "react-infinite-scroll-component";

export const InfiniteScroll = styled(Infinite)`
   overflow-x: hidden !important;
`;